import React from 'react';

import { SvgProps } from '../enums';

export const FlagTH: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55148"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55148)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8H16V12H0V8Z"
        fill="#F50101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V3H0V0Z"
        fill="#F50101"
      />
      <path
        d="M0 3.25H-0.75V4V8V8.75H0H16H16.75V8V4V3.25H16H0Z"
        fill="#3D58DB"
        stroke="white"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);
